// extracted by mini-css-extract-plugin
module.exports = {"questionIcon":"CreditCardForm_questionIcon__b84FZ"};